var React   = require("react");

var Loading = require("patternity/lib/loading");
var { withNamespaces } = require('react-i18next');

var ChallengesLoading = React.createClass({
  PropTypes : {
    loadingChallenges : React.PropTypes.bool,
    experienceCount : React.PropTypes.number.isRequired,
    challengeStage : React.PropTypes.string.isRequired
  },

  getDefaultProps : function(){
    return {
      loadingChallenges : true,
      experienceCount : 0,
      challengeStage : ""
    };
  },

  render : function(){
    return (
      <div className={"challenges-loading " + this._showLoading()}>
        <Loading isBlock={true} size="large" />
        <span className="hold-on">{this.props.t('Hold on while we fetch the latest challenges for you!')}</span>
      </div>
    );
  },

  _showLoading : function(){
    if(this.props.loadingChallenges === false) {
      return "";
    }

    if(this.props.challengeStage === "Available"){
      if(this.props.experienceCount === 0) {
        return "show";
      }
    } else {
      return "show";
    }
  }
});

module.exports = withNamespaces()(ChallengesLoading);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenges_loading.jsx